/* Verify age acceptance before the storefront popup initializes. */
(function () {
  'use strict';
  var key = 'asos-age-confirmed-until';
  var duration = 30 * 24 * 60 * 60 * 1000;
  function cookieValue(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return part.slice(prefix.length);
    }
    return '';
  }
  function writeCookie(name, value, seconds) {
    document.cookie = name + '=' + value + '; Max-Age=' + seconds + '; Path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }
  function storedUntil() {
    var until = Number(cookieValue(key)) || 0;
    try { until = Math.max(until, Number(localStorage.getItem(key)) || 0); }
    catch (error) { /* Cookie fallback. */ }
    return until;
  }
  var now = Date.now();
  var until = storedUntil();
  var valid = until > now && until <= now + duration;

  /* Preflight runs synchronously before the storefront popup initializes. */
  if (valid) {
    writeCookie('newsletter-popup', 'closed', Math.ceil((until - now) / 1000));
    writeCookie(key, String(until), Math.ceil((until - now) / 1000));
  } else {
    writeCookie(key, '', 0);
    writeCookie('newsletter-popup', '', 0);
    try { localStorage.removeItem(key); } catch (error) { /* Cookie fallback. */ }
  }

  function ready() {
    var popup = document.getElementById('halo-newsletter-popup');
    if (valid) {
      if (popup) popup.remove();
      document.body.classList.remove('newsletter-show', 'show-newsletter-image');
      return;
    }
    if (!popup) return;
    popup.setAttribute('data-expire', '30');
    popup.addEventListener('click', function (event) {
      var button = event.target.closest('[data-close-newsletter-popup]');
      if (!button || !popup.contains(button) || button.textContent.trim().toLowerCase() !== 'sim') return;
      var expires = Date.now() + duration;
      writeCookie(key, String(expires), 30 * 86400);
      writeCookie('newsletter-popup', 'closed', 30 * 86400);
      try { localStorage.setItem(key, String(expires)); } catch (error) { /* Cookie fallback. */ }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
